import { render, staticRenderFns } from "./UsuariosDetalleCuenta.vue?vue&type=template&id=41e72015&"
import script from "./UsuariosDetalleCuenta.vue?vue&type=script&lang=js&"
export * from "./UsuariosDetalleCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports